<template>
  <div class="sqhd-wrapper">
    <div class="sqhd-head" v-if="isShowDefaultTitle">社区活动</div>
    <div class="sqhd-item">
      <div class="item-top">
        <img src="./xi.png" class="top-pic">
        <div class="top-info">
          党组织活动学习习平同志动学习习平同志系志系列讲...
          <div class="top-foot">
            <div class="iconfont icon-dangzhibugongzuo partyicon"></div>
            <div style="font-size:16px">西交第一党支部</div>
          </div>
        </div>
      </div>
      <x-scroll :contentArr="num" :height="85" :lineNum="3" :width="200" :time="3000" :chixuTime="3">
        <div class="item-down" slot="scroll" slot-scope="props">
          <img src="./1.png" style="width: 60px;height:60px;border-radius: 50%">
          <div class="baoming">
            <div style="padding-bottom: 5px">张三</div>
            <div>刚刚报名</div>
          </div>
        </div>
      </x-scroll>
    </div>
  </div>
</template>

<script>
  import xScroll from '../../../components/xScroll'
  export default {
    components: {
      xScroll
    },
    props:{
      isShowDefaultTitle: {
        default: true,
        type: Boolean,
      }
    },
    data () {
      return {
        num:[1,2,3,4]
      }
    }
  }
</script>

<style scoped>
  .sqhd-wrapper{
    width:100%;
    background: #fff;
    border:1px solid #fff;
    border-radius: 5px;
    padding-top: 20px;
    color:#444;
  }
  .sqhd-head{
    height: 20px;
    line-height: 20px;
    border-left: 3px solid #d22b2b;
    padding-left: 10px;
    font-size: 16px;
  }
  .sqhd-item{
    width: 100%;
    height:260px;
    padding: 20px;
  }
  .item-top{
    display: flex;
  }
  .partyicon{
    font-size: 16px;
    color: #ff5740;
    padding-right:5px
  }
  .top-info{
    font-size: 20px;
    position: relative;
    padding:5px 0;
  }
  .top-pic{
    height: 130px;
    width: 220px;
    margin-right: 15px
  }
  .top-foot{
    position: absolute;
    bottom:5px;
    left:0;
    display:flex
  }
  .item-down{
    width: 220px;
    display: flex;
    padding-top: 25px
  }
  .baoming{
    display: flex;
    padding-left:10px;
    flex-flow: column;
    justify-content:center;
    text-align: left;
    font-size:13px
  }
</style>
